// extracted by mini-css-extract-plugin
export var hideEditor = "_ic-2";
export var infoIcon = "_ic-3";
export var label = "_ic-1";
export var labelContainer = "_ic-0";
export var readonlyText = "_ic-4";